import React from "react";
import LinkListItemWithIcon from "../LinkListItemWithIcon/LinkListItemWithIcon";
import uploadImage from "../../assets/icon/hochladen.svg";
import bookingImage from "../../assets/icon/icon_buchen.svg";
import { List } from "@mui/material";
import { BackofficeUser, Roles } from "../../types/BackofficeUser";
import { userHasOneOfTheseRoles } from "../../services/backofficeUserService";
import wiretransferImage from "../../assets/icon/icon_wiretransfer.svg";
import { usePendingTasks } from "../../hooks/usePendingTasks";

type PaymentsProps = {
  currentUser: BackofficeUser;
};

const Payments = ({ currentUser }: PaymentsProps) => {
  const pendingTasks = usePendingTasks();

  return (
    <List>
      <LinkListItemWithIcon
        title={"Überweisungen"}
        description={"z.B. Fremdgeldzahlungen oder Gerichtskostenüberschüsse auskehren"}
        to={"/services/tools/ueberweisung"}
        imageIcon={wiretransferImage}
      />
      {userHasOneOfTheseRoles(currentUser, [Roles.admin, Roles.banking]) && (
        <LinkListItemWithIcon
          title={"Hochladen"}
          description={"Aus Commerzbank exportierte Zahlungen importieren"}
          to={"/services/tools/zahlungen-hochladen"}
          imageIcon={uploadImage}
        />
      )}
      {userHasOneOfTheseRoles(currentUser, [Roles.admin, Roles.accounting, Roles.accountmanager, Roles.developer]) && (
        <LinkListItemWithIcon
          title={"Zahlungen buchen"}
          description={"Eingehende und Ausgehende Zahlungen manuell auf Mandantenkonten buchen"}
          to={"/services/tools/zahlungseingaenge-buchen"}
          imageIcon={bookingImage}
          badgeContent={pendingTasks?.bankPaymentsToCheckCount}
        />
      )}
    </List>
  );
};

export default Payments;
